interface Params {
  hex: string;
  opacity: number;
}

const hexToRgba = ({ hex, opacity }: Params) => {
  const regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/;
  const matches = hex.match(regex);
  const r = parseInt(matches[1], 16);
  const g = parseInt(matches[2], 16);
  const b = parseInt(matches[3], 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export default hexToRgba;
